export default "__VITE_ASSET__BuuGp9wj__"